// ErrorReportCheck.tsx — CORE-1998: test-build buttons that send a JS error and
// crash the app natively, so QA can confirm both land in GlitchTip (project
// frontend) with the right environment, release and a readable stack.
// Native only — EnvSwitcher renders it in its card, which store builds never show.
import React, { useState } from 'react';
import { Pressable, StyleSheet, Text } from 'react-native';
import * as Sentry from '@sentry/react-native';

/** Named, so the de-minified stack in GlitchTip points back here. */
function throwErrorReportProbe(): never {
  throw new Error(`CORE-1998 test JS error ${new Date().toISOString()}`);
}

export default function ErrorReportCheck(): React.ReactElement {
  const [status, setStatus] = useState<string | null>(null);

  const sendJsError = async () => {
    const client = Sentry.getClient();
    // A missing client means Sentry.init never ran here — one of the causes the
    // ticket asks to rule out. A dev client runs it with sending switched off.
    if (!client) {
      setStatus('Sentry не запущен в этой сборке');
      return;
    }
    if (client.getOptions().enabled === false) {
      setStatus('Отправка выключена (dev-сборка)');
      return;
    }
    let eventId = '';
    try {
      throwErrorReportProbe();
    } catch (e) {
      eventId = Sentry.captureException(e);
    }
    const handedOver = await Sentry.flush();
    setStatus(`${handedOver ? 'Передано SDK' : 'Не передано SDK'}: ${eventId}`);
  };

  return (
    <>
      <Text style={styles.title}>Проверка GlitchTip</Text>
      <Pressable style={styles.row} onPress={sendJsError} testID="errorCheck-js" accessibilityRole="button">
        <Text style={styles.rowText}>Тестовая ошибка JS</Text>
      </Pressable>
      <Pressable
        style={styles.row}
        onPress={() => Sentry.nativeCrash()}
        testID="errorCheck-native"
        accessibilityRole="button"
      >
        <Text style={styles.rowText}>Нативный крэш (приложение закроется)</Text>
      </Pressable>
      {status ? <Text style={styles.status}>{status}</Text> : null}
    </>
  );
}

const styles = StyleSheet.create({
  title: { fontSize: 13, fontWeight: '700', color: '#181411', marginTop: 14, marginBottom: 8 },
  row: {
    paddingVertical: 10,
    paddingHorizontal: 14,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#e5e5e5',
    marginBottom: 8,
  },
  rowText: { fontSize: 14, color: '#181411' },
  status: { fontSize: 11, color: '#6b6b6b', lineHeight: 15 },
});
